var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPackagesSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.824219,
    y: 0.000396729,
    width: 10.717,
    height: 10.717,
    rx: 1.33962,
    fill: "#07794C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3744 0.000396729L4.99285 0.000396729C4.83494 0.000396729 4.6835 0.0631249 4.57185 0.174782C4.46019 0.286439 4.39746 0.437878 4.39746 0.595785L4.39746 5.35889L6.18362 4.46581L7.96979 5.35889L7.96979 0.595785C7.96979 0.437878 7.90706 0.286439 7.7954 0.174782C7.68375 0.0631249 7.53231 0.000396729 7.3744 0.000396729Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackagesSvg);
export default __webpack_public_path__ + "static/media/Packages_svg.e1bffdc7650ab03299a44d1dbc32078b.svg";
export { ForwardRef as ReactComponent };